export enum ServiceOperationOutcome {
  Unknown = 0,

  Success = 10,

  GeneralFailure = 20,

  ServerException = 30,

  WrongParams = 40,

  AccessNotAllowed = 50,

  NotImplemented = 60,

  NoDataFound = 70,

  FailedAuthentication = 80,

  ConnectionFailure = 90
}
